import { PageStyle, cursorNone, Button, ButtonStyle, CommonAction, CustomToastrAction, TRANSLATION,useTranslation} from '@/imports-files/pages/clients/jobs/automations';


export class VideoQaAction
{
  constructor()
  {
    this.customToastrAction  =  new CustomToastrAction();
    this.commonAction = new CommonAction();
  }

  renderInputComponent = inputProps => (
      <input className = {PageStyle.Form__Input} autoComplete={"password"}
      {...inputProps} />
  );

  shouldRenderSuggestions(value){
    return value.trim().length >= 3
  }

  isEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@\.]+$/.test(email);
  }

  renderMemberInputComponent = inputProps => (
     <div className="buttonIn AutoSuggestInput__Tags" style={inputProps.styleError}>
        {inputProps.selectedValues?.map((item, itemIndex) => (
          <div className={PageStyle.SetupPopup__Tags} key={`interview_email_${inputProps.index}_${itemIndex}`}>
            {item.name ? (<span>{item.name}</span>) : (<span>{item.email}</span>)}
            <button
              ButtonStyle={`${ButtonStyle.nobgbutton}`}
              type="button"
              onClick={() => {
                inputProps.videoQaAction.handleDelete(inputProps.formik, itemIndex)
              }}
            > {inputProps.closeIcon}
            </button>
          </div>
        ))}
      <input className = {PageStyle.Form__Input} autoComplete="password"
      {...inputProps} />
      <Button buttonstyle={`${ButtonStyle.nobgbutton} addbtn ${cursorNone(inputProps.editable)}`} disabled={inputProps.disabled} onClick={(event) => inputProps.videoQaAction.onAddClick(event, inputProps)}>{TRANSLATION('button:add:default')}</Button>
    </div>
  );

  onSuggestionSelection(formik, old_ids, id, old_initials, new_initial){
    if(!(old_ids.includes(id) || old_ids.includes(id.toString())))
     {
      old_ids.unshift(id)
      old_initials.unshift(new_initial)
      formik.setFieldValue(`videoqa.member_emails`, [...old_ids])
      formik.setFieldValue(`videoqa.member_initials`, [...old_initials])
     }
  }

  onAddClick = (event, params) => {
    let email = params.value
    if(this.isEmail(email)){
      params.videoQaAction.onSuggestionSelection(params.formik, params.formik.values.videoqa.member_emails, email, params.formik.values.videoqa.member_initials, {email: email, name_initials: null, name: null })
      params.setStageEmail({value: '', error: ''})
    }
    else{
      params.setStageEmail({value: email, error: 'Please enter valid email'})
    }
  }

  handleKeyDown(event, formik, setStageEmail){
    if (["Enter"].includes(event.key)) {
      event.preventDefault();
      let email = event.target.value
      if(this.isEmail(email)){
        this.onSuggestionSelection(formik, formik.values.videoqa.member_emails, email, formik.values.videoqa.member_initials, {email: email, name_initials: null, name: null })
        setStageEmail({value: '', error: ''})
      }
      else{
        setStageEmail({value: email, error: 'Please enter valid email'})
      }
    }
  }

  handleDelete(formik, itemIndex){
    let member_emails = formik.values.videoqa.member_emails
    let member_initials = formik.values.videoqa.member_initials
    member_emails.splice(itemIndex, 1)
    member_initials.splice(itemIndex, 1)
    formik.setFieldValue(`videoqa.member_emails`, [...member_emails])
    formik.setFieldValue(`videoqa.member_initials`, [...member_initials])
  };

}